import React from "react";

import t from "../../../lib/translate";

import * as styles from "./component.module.less";

const defaultDomainName = process.env.GATSBY_BASE_URL.replace(
    /^https?:\/\//,
    ""
);

export default function CookieBannerItem({
    description,
    cookies: cookiesData,
    functions
}) {
    return (
        <div className={styles.cookieItemWrapper}>
            <div className={styles.cookieItemContent}>
                <p>{description}</p>

                {cookiesData.map((cookieData) => (
                    <div
                        key={cookieData.title}
                        className={styles.cookieDescription}
                    >
                        <p className={styles.boldText}>{cookieData.title}</p>

                        <p>{cookieData.content}</p>

                        <p>
                            {t("cookie.domain-name")}:{" "}
                            {cookieData.domainname || defaultDomainName}
                        </p>

                        <p>
                            {t("cookie.expiry")}: {cookieData.expiry}
                        </p>

                        <p>
                            {t("cookie.provider")}: {cookieData.provider}
                        </p>

                        <p>
                            {t("cookie.type")}: {cookieData.typ}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
